export default {
  namespaced: true,

  state: {
    page: {},
    search: localStorage.getItem('pagination/search') || '',
    filters: localStorage.getItem('pagination/filters') || {},
    lastRoute: localStorage.getItem('pagination/lastRoute') || '',
    lastPlayer: null // guardo el jugador actual para la paginacion condicion salarial

  },

  mutations: {
    setPage (state, value) {
      state.page = value
    },
    setSearch (state, value) {
      state.search = value
      localStorage.setItem('pagination/search', value)
    },
    setFilters (state, value) {
      state.filters = value
      localStorage.setItem('pagination/filters', value)
    },
    setLastRoute (state, value) {
      state.lastRoute = value
      localStorage.setItem('pagination/lastRoute', value)
    },
    setLastPlayer (state, player) {
      state.lastPlayer = player // mutacion para cambiar el jugador actual
    }
  }
}
